import loader from '@/utils/loader'
let components = loader.getByComponentName(require.context('./', true, /\.(vue)$/))

export default {
  install (Vue) {
    Vue.mixin({
      components
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/index.js